/**
 * Cart quantity +/- fix — workaround for the Samita Wholesale app (B2B).
 *
 * Problem: in B2B, the Samita Wholesale app (samitaws-* attributes) re-processes
 * the cart drawer line items on every /cart.js refresh and stacks its own click
 * listeners on the +/- buttons. One of them blocks the theme's handler
 * (QuantityInput.onButtonClick in theme.js), so clicking +/- never steps the value
 * and never fires POST /cart/change — the customer must remove the line and re-add
 * from the product page. The native quantity field still works (form submit).
 *
 * Fix: a single capture-phase click listener on document. Capture runs BEFORE every
 * bubble-phase listener (the 10+ stacked ones are all useCapture:false), so we take
 * over, replicate the theme's step logic, call updateQuantity() directly, and stop
 * the click so Samita's handlers can't interfere. Works for B2B and B2C identically.
 *
 * Remove this file (and its <script> include in layout/theme.liquid) once Samita
 * ships a fix for their drawer integration.
 */
(function () {
  function onCartQtyButtonClick(event) {
    const button = event.target.closest('.quantity__button');
    if (!button) return;

    const quantityInput = button.closest('quantity-input');
    if (!quantityInput) return;

    // Only act inside the theme's cart contexts (drawer or cart page).
    const cartItems = button.closest('cart-drawer-items') || button.closest('cart-items');
    if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

    const input = quantityInput.querySelector('input.quantity__input');
    if (!input) return;

    // We own this click: prevent the stacked Samita/theme listeners from running.
    event.preventDefault();
    event.stopImmediatePropagation();

    // Replicate QuantityInput.onButtonClick (assets/theme.js) step semantics.
    const previousValue = input.value;
    const min = parseInt(input.dataset.min);
    const step = parseInt(input.step);

    if (button.name === 'plus') {
      if (min > step && input.value == 0) {
        input.value = input.dataset.min;
      } else {
        input.stepUp();
      }
    } else {
      input.stepDown();
      if (input.dataset.min === previousValue) {
        input.value = parseInt(input.min) || 0;
      }
    }

    if (previousValue !== input.value) {
      cartItems.updateQuantity(
        input.dataset.index,
        input.value,
        button.name,
        input.dataset.quantityVariantId
      );
    }
  }

  document.addEventListener('click', onCartQtyButtonClick, true);
})();
